<template>
  <section>
    <div class="top-header-with-banner" id="section-3">
      <h2>{{ $t("FastTrack.ServiceReservation") }}  {{ title }}</h2>
      <div class="content-current">
        <div class="card-header">
          <h4>
            {{ $t("FastTrack.DataEntry") }} 
            <span style="color: #08446a; font-weight: 600">{{ title }}</span>
          </h4>
        </div>
        <div class="row content-current">
          <div class="col-md-12 col-xs-12">
            <div class="box box-info">
              <div class="box-header">
                <h3 class="box-title">
                  <!-- <i class="beside-title-small icon-doc-text-inv-1" style="color: #178a00"></i> -->
                  <label>{{ $t("FastTrack.Reserveinformation") }} </label>
                </h3>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-md-4 col-sm-4">
                    <label>{{ $t("FastTrack.Services") }}: </label>
                    {{ reservedData.serviceName }}
                    <span v-if="reservedData.scheduleDescription">( {{ reservedData.scheduleDescription }})</span>
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <label>{{ $t("FastTrack.GuestCount") }}: </label>
                    {{ reservedData.adultCount }} {{ $t("FastTrack.Adult") }}
                    {{ reservedData.childCount }} {{ $t("FastTrack.Child") }}
                    {{ reservedData.infantCount }} {{ $t("FastTrack.Infant") }}
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <label>{{ $t("FastTrack.TotalReserved") }}: </label>
                    {{ reservedData.guestCount }} {{ $t("FastTrack.Person") }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 col-sm-4">
                    <label>{{ $t("FastTrack.EntryDate") }}: </label>
                    {{ reservedData.toDate | persianDate("YYYY/MM/DD") }}
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <label>{{ $t("FastTrack.TimePlan") }}: </label>
                    {{ reservedData.scheduleTime }}
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <label> {{ $t("Price") }}: </label>
                    {{ reservedData.totalPrice | numFormat | rial }}
                  </div>
                </div>
                <div v-if="reservedData.addOnOptionList.length > 0">
                  <hr />
                  <div class="box-header">
                    <h3 class="box-title">
                      <i class="icon-dot-3" style="color: #e04f67"></i><label>{{ $t("FastTrack.OtherServices") }} </label>
                    </h3>
                  </div>
                  <template v-for="addon in reservedData.addOnOptionList">
                    <div class="row" v-if="addon.selectedCount > 0">
                      <div class="col-md-4 col-sm-4">
                        <label> {{ $t("Name") }}: </label>
                        {{ addon.name }}
                      </div>

                      <div class="col-md-4 col-sm-4">
                        <label>{{ $t("Count") }}: </label>
                        {{ addon.selectedCount }}
                      </div>
                      <div class="col-md-4 col-sm-4">
                        <label> {{ $t("Price") }} : </label>
                        {{
                            (addon.itemPrice * addon.selectedCount) | numFormat
                        }}
                        {{ $t("Rial") }}
                      </div>
                    </div>
                  </template>
                  <hr />
                  <div class="row">
                    <div class="col-md-4 col-sm-4">
                      <label> </label>
                    </div>

                    <div class="col-md-4 col-sm-4">
                      <label> </label>
                    </div>
                    <div class="col-md-4 col-sm-4">
                      <label> {{ $t("FastTrack.TotalPrice") }} : </label>
                      {{ reservedData.totalAmount | numFormat }}
                       {{ $t("Rial") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box box-success content-current">
          <div class="box-header">
            <h3 class="box-title">
              <!-- <i class="beside-title-small icon-user-5" style="color: #d5ab3d"></i
          > -->
              <label>{{ $t("FastTrack.CustomerInformation") }}</label>
            </h3>
          </div>

          <div class="row">
            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">
                <input type="text" v-model="data.firstName" @blur="$v.data.firstName.$touch()"
                  :class="{ invalid: $v.data.firstName.$error }" />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label><span class="validation-color">*</span>   {{ $t("Name") }}</label>
                <p class="text-danger" v-if="!$v.data.firstName.required && $v.data.firstName.$dirty">
                  {{ $t("PleaseEnterName") }}
                </p>
                <p class="text-danger" v-if="
                  providerId === 2 &&
                  !$v.data.firstName.checkIsLatin &&
                  $v.data.firstName.$dirty
                ">
                  {{ $t("PleaseEnterEnglishName") }}
                </p>
              </div>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">
                <input class="col-xs-12" v-model="data.lastName" type="text" @blur="$v.data.lastName.$touch()"
                  :class="{ invalid: $v.data.lastName.$error }" />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label  class="special-labels"><span class="validation-color">*</span> {{ $t("LName") }}</label>
                <p class="text-danger" v-if="!$v.data.lastName.required && $v.data.lastName.$dirty">
                   {{ $t("PleaseEnterLastName") }}
                </p>
                <p class="text-danger" v-if="
                  providerId === 2 &&
                  !$v.data.lastName.checkIsLatin &&
                  $v.data.lastName.$dirty
                ">
                  {{ $t("PleaseEnterEnglishLastName") }}
                </p>
              </div>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">
                <input v-model="data.mobileNumber" @blur="$v.data.mobileNumber.$touch()" :class="{
                  invalid:
                    mobileValidation.errors.length &&
                    $v.data.mobileNumber.$dirty,
                }" maxlength="11" />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label  class="special-labels"><span class="validation-color">*</span> {{ $t("MobileNumber") }}</label>
                <p class="text-danger" v-if="
                  mobileValidation.errors.length &&
                  $v.data.mobileNumber.$dirty
                ">
                  {{ $t("EnterNumberNotValid") }}
                </p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">

                <input style="margin-top: 7px !important" v-model="data.nationalCode" type="text"
                  @blur="$v.data.nationalCode.$touch()" :class="{ invalid: $v.data.nationalCode.$error }" />
                <label  class="special-labels" v-if="providerId === 2"><span class="validation-color">*</span>{{ $t("Passport") }}</label>
                <label  class="special-labels" v-if="providerId === 1"><span class="validation-color"></span> {{ $t("NationalCode") }}</label>
                <p class="text-danger" v-if="
                  data.selectedNationalId === 2 &&
                  $v.data.nationalCode.$error &&
                  $v.data.nationalCode.$dirty
                ">
                  {{ $t("PassportIncludesNumbersAndEnglishLetters") }}
                </p>

                <p class="text-danger" v-if="
                  data.selectedNationalId === 1 &&
                  $v.data.nationalCode.$error &&
                  $v.data.nationalCode.$dirty
                ">
                  {{ $t("PleaseEnterNationalCodeCorrectFormat") }}
                </p>
              </div>
            </div>

            <div class="col-md-4 col-xs-12">
              <div class="select">
                <select class="select-text" v-model="data.gender">
                  <option v-for="item in genderItems" :value="item.key" :key="item.key">
                    {{ item.value }}
                  </option>
                </select>
                <p class="text-danger" v-if="!$v.data.gender.required && $v.data.gender.$dirty">
                  {{ $t("PleaseChooseSex") }}
                </p>
                <span class="select-highlight"></span>
                <span class="select-bar"></span>
                <label class="select-label">{{ $t("Sex") }}</label>
              </div>


              <!-- <label>جنسیت</label>
              <div class="styled-select select">
                <select v-model="data.gender">
                  <option v-for="item in genderItems" :value="item.key" :key="item.key">
                    {{ item.value }}
                  </option>
                </select>
                <p class="text-danger" v-if="!$v.data.gender.required && $v.data.gender.$dirty">
                  لطفا جنسیت را انتخاب نمائید
                </p>
              </div> -->
            </div>

            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">
                <input type="text" v-model="data.email" @blur="$v.data.email.$touch()"
                  :class="{ invalid: $v.data.email.$error }" />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label  class="special-labels"><span class="validation-color"> </span>{{ $t("Email") }}</label>
                <p class="text-danger" v-if="!$v.data.email.email">
                  {{ $t("EmailNotValid") }}
                </p>
              </div>
            </div>
          </div>
          <div class="row" v-if="providerId === 1">
            <div class="col-md-12 col-xs-12">
              <div class="form-group">
                <textarea class="style-textarea" :placeholder="$t('Description')" type="text" rows="2"
                  v-model="data.customerRequest" />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label><span class="validation-color"> </span></label>
              </div>
            </div>
          </div>
          <div class="row" v-if="providerId === 2">
            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">
                <input type="text" v-model="data.flightNumber" @blur="$v.data.flightNumber.$touch()"
                  :class="{ invalid: $v.data.flightNumber.$error }" />

                <label><span class="validation-color">*</span>  {{ $t("FlightNumber") }}</label>
                <p class="text-danger" v-if="
                  !$v.data.flightNumber.required &&
                  $v.data.flightNumber.$dirty
                ">
                  {{ $t("PleaseEnterFlightNumber") }}
                </p>
              </div>
            </div>
            <div class="col-md-8 col-lg-8 col-xs-12">
              <label><span class="validation-color"> </span></label>
              <textarea style="width: 100%;" class="style-textarea" type="text" :placeholder="$t('Description')" rows="2"
                v-model="data.customerRequest" />
            </div>

          </div>
        </div>

        <template v-if="providerId === 2 && guestCount > 1">
          <div class="box box-success content-current">
            <div class="box-header">
              <h3 class="box-title">
                <i class="icon-users-1" style="color: #2a69b1"></i><label> {{ $t("FastTrack.Companions") }}</label>
              </h3>
            </div>

            <form @submit.prevent="onSubmit">
              <!--------------------------  adult guests      --------------------------------->
              <div v-for="(guest, i) in guestDetails.adultCount" :set="(v = $v.guestDetails.adultCount.$each[i])"
                v-bind:key="i.id" class="row">
                <div class="col-md-4 col-xs-12">
                  <div class="group_mdi">
                    <input type="text" v-model="guest.firstName"
                      :class="{ invalid: v.firstName.$error }" />
                    <label class="special-labels"><span class="validation-color">*</span> {{ $t("FastTrack.AdultName") }}
                      {{ i + 2 }}</label>
                    <!-- <p
                  class="text-danger"
                  v-if="!v.firstName.required && v.firstName.$dirty"
                >
                  لطفا نام بزرگسال {{ i + 2 }} را وارد کنید
                </p> -->
                  </div>
                </div>
                <div class="col-md-4 col-xs-12">
                  <div class="group_mdi">
                    <input class="col-xs-12" type="text" v-model="guest.lastName"
                      :class="{ invalid: v.lastName.$error }" />
                    <label class="special-labels"><span class="validation-color">*</span> {{ $t("FastTrack.AdultLastName") }}
                       {{ i + 2 }}</label>

                    <!-- <p
                  class="text-danger"
                  v-if="!v.lastName.required && v.lastName.$dirty"
                >
                  لطفا نام خانوادگی بزرگسال {{ i + 2 }} را وارد کنید
                </p> -->
                  </div>
                </div>
                <div class="col-md-4 col-xs-12">
                  <div class="group_mdi">
                    <input class="col-xs-12" type="text" v-model="guest.nationalCode"
                      :class="{ invalid: v.nationalCode.$error }" maxlength="10" />
                    <label class="special-labels"><span class="validation-color">*</span> {{ $t("FastTrack.AdultPassword") }}
                       {{ i + 2 }}</label>

                    <p class="text-danger" v-if="v.nationalCode.$error && v.nationalCode.$dirty">                      
                      {{ $t("PassportIncludesNumbersAndEnglishLetters") }}
                    </p>
                  </div>
                </div>
              </div>
              <!--------------------------  end adult guests      --------------------------------->

              <!--------------------------  child guests      --------------------------------->
              <div v-for="(guest, i) in guestDetails.childCount" :set="(v = $v.guestDetails.childCount.$each[i])"
                class="row">
                <div class="col-md-4 col-xs-12">
                  <div class="group_mdi">
                    <label class="special-labels"><span class="validation-color">*</span> {{ $t("FastTrack.ChildsName") }}
                      {{ i + 1 }}</label>
                    <input type="text" v-model="guest.firstName"
                      :class="{ invalid: v.firstName.$error }" />
                    <!-- <p
                  class="text-danger"
                  v-if="!v.firstName.required && v.firstName.$dirty"
                >
                  لطفا نام کودک {{ i + 1 }} را وارد کنید
                </p> -->
                    <p class="text-danger" v-if="
                      providerId === 2 &&
                      !v.firstName.checkIsLatin &&
                      v.firstName.$dirty
                    ">
                      {{ $t("FastTrack.PleaseEnterEnglishChildsName") }}
                    </p>
                  </div>
                </div>
                <div class="col-md-4 col-xs-12">
                  <div class="group_mdi">
                    <label class="special-labels"><span class="validation-color">*</span> {{ $t("FastTrack.ChildsLastName") }}
                      {{ i + 1 }}</label>
                    <input class=" col-xs-12" type="text" v-model="guest.lastName"
                      :class="{ invalid: v.lastName.$error }" />
                    <!-- 
                <p
                  class="text-danger"
                  v-if="!v.lastName.required && v.lastName.$dirty"
                >
                  لطفا نام خانوادگی کودک {{ i + 1 }} را وارد کنید
                </p> -->
                    <p class="text-danger" v-if="
                      providerId === 2 &&
                      !v.lastName.checkIsLatin &&
                      v.lastName.$dirty
                    ">
                      {{ $t("FastTrack.PleaseEnterEnglishChildsLastName") }}
                    </p>
                  </div>
                </div>
                <div class="col-md-4 col-xs-12">
                  <div class="group_mdi">
                    <label class="special-labels"><span class="validation-color">*</span>  {{ $t("FastTrack.ChildsPassport") }}
                       {{ i + 1 }}</label>

                    <input v-model="guest.nationalCode" type="text"
                      :class="{ invalid: v.nationalCode.$error }" maxlength="10" />

                    <p class="text-danger" v-if="v.nationalCode.$error && v.nationalCode.$dirty">
                      {{ $t("PassportIncludesNumbersAndEnglishLetters") }}
                      
                    </p>
                  </div>
                </div>
              </div>
              <!--------------------------  end child guests      --------------------------------->

              <!--------------------------  infant guests      --------------------------------->
              <div v-for="(guest, i) in guestDetails.infantCount" :set="(v = $v.guestDetails.infantCount.$each[i])"
                class="row">
                <div class="col-md-4 col-xs-12">
                  <div class="group_mdi">
                    <label class="special-labels"><span class="validation-color">*</span>  {{ $t("FastTrack.InfantsName") }}
                      {{ i + 1 }}</label>
                    <input type="text" v-model="guest.firstName"
                      :class="{ invalid: v.firstName.$error }" />
                    <!-- <p
                  class="text-danger"
                  v-if="!v.firstName.required && v.firstName.$dirty"
                >
                  لطفا نام نوزاد {{ i + 1 }} را وارد کنید
                </p> -->
                    <p class="text-danger" v-if="
                      providerId === 2 &&
                      !v.firstName.checkIsLatin &&
                      v.firstName.$dirty
                    ">
                      {{ $t("FastTrack.PleaseEnterEnglishInfantsName") }}
                    </p>
                  </div>
                </div>
                <div class="col-md-4 col-xs-12">
                  <div class="group_mdi">
                    <label class="special-labels"><span class="validation-color">*</span>  {{ $t("FastTrack.InfantsLastName") }}
                       {{ i + 1 }}</label>
                    <input class="col-xs-12" type="text" v-model="guest.lastName"
                      :class="{ invalid: v.lastName.$error }" />

                    <!-- <p
                  class="text-danger"
                  v-if="!v.lastName.required && v.lastName.$dirty"
                >
                  لطفا نام خانوادگی نوزاد {{ i + 1 }} را وارد کنید
                </p> -->
                    <p class="text-danger" v-if="
                      providerId === 2 &&
                      !v.lastName.checkIsLatin &&
                      v.lastName.$dirty
                    ">
                      {{ $t("FastTrack.InfantPleaseEnterEnglishInfantsLastNamesLastName") }}
                    </p>
                  </div>
                </div>
                <div class="col-md-4 col-xs-12">
                  <div class="group_mdi">
                    <label class="special-labels"><span class="validation-color">*</span>   {{ $t("FastTrack.InfantsPassport") }}
                       {{ i + 1 }}</label>

                    <input v-model="guest.nationalCode" type="text"
                      :class="{ invalid: v.nationalCode.$error }" maxlength="10" />

                    <p class="text-danger" v-if="v.nationalCode.$error && v.nationalCode.$dirty">
                      {{ $t("PassportIncludesNumbersAndEnglishLetters") }}
                    </p>
                  </div>
                </div>
              </div>
              <!--------------------------  end infant guests      --------------------------------->
            </form>
          </div>
        </template>
        <div class="btn-align">
          <button type="submit" class="btn-profile" @click="onSubmit">
            {{ $t("FastTrack.Continue") }}
          </button>
          <button type="submit" class="btn-profile" @click.prevent="backToSearch()" style="background-color: #ff5874">
            {{ $t("Back") }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  required,
  email,
  maxLength,
  minLength,
  requiredIf,
} from "vuelidate/lib/validators";
import store from "../../views/tourism/store/index";

export default {
  name: "tourismBook",
  store: store,
  components: {},
  data() {
    return {
      totalAmount: 0,
      data: {
        customerRequest: "",
        firstName: "",
        lastName: "",
        mobileNumber: "",
        emailAddress: "",
        isCustomerReserver: true,
        gender: 1,
        birthDate: "",
        nationalCode: "",
        flightNumber: "",
        classType: 1,
        selectedNationalId: 2,
      },
      reservedData: {},
      genderItems: [
        { key: 1, value: "مرد" },
        { key: 2, value: "زن" },
      ],

      classTypeItems: [
        { key: 1, value: "Economy Class" },
        { key: 2, value: "Business Class" },
        { key: 3, value: "First Class" },
      ],
      customerInfo: {},
      providerId: 0,
      providerName: "fasttrack",
      nationalType: [
        { id: 1, title: "کدملی" },
        { id: 2, title: "پاسپورت" },
      ],

      title: "",
      guestDetails: { adultCount: [], childCount: [], infantCount: [] },
      guestCount: 0,
      rules: [
        { message: "شماره وارد شده معتبر نمی باشد.", regex: /(09)[0-9]{9}/ },
      ],
      passportRules: [
        { message: "اعداد انگلیسی و حروف", regex: /[A-Za-z-09\s]+/ },
      ],
    };
  },
  validations() {
    if (this.data.selectedNationalId === 1) {
      return {
        data: {
          firstName: { required },
          lastName: { required },
          flightNumber: {
            required: requiredIf(function (model) {
              const isValid = this.providerId == 2 ? true : false;
              return isValid;
            }),
          },
          classType: { required },
          mobileNumber: {
            required,
            maxLength: maxLength(11),
            minLength: minLength(11),
          },
          email: { email, maxLength: maxLength(100) },
          gender: { required },
          nationalCode: {
            checkMelliCode: (meli_code) => {
              if (meli_code.length > 0) {
                if (
                  meli_code == "1111111111" ||
                  meli_code == "0000000000" ||
                  meli_code == "2222222222" ||
                  meli_code == "3333333333" ||
                  meli_code == "4444444444" ||
                  meli_code == "5555555555" ||
                  meli_code == "6666666666" ||
                  meli_code == "7777777777" ||
                  meli_code == "8888888888" ||
                  meli_code == "9999999999"
                ) {
                  return false;
                }
                var c = parseInt(meli_code.charAt(9));
                var n =
                  parseInt(meli_code.charAt(0)) * 10 +
                  parseInt(meli_code.charAt(1)) * 9 +
                  parseInt(meli_code.charAt(2)) * 8 +
                  parseInt(meli_code.charAt(3)) * 7 +
                  parseInt(meli_code.charAt(4)) * 6 +
                  parseInt(meli_code.charAt(5)) * 5 +
                  parseInt(meli_code.charAt(6)) * 4 +
                  parseInt(meli_code.charAt(7)) * 3 +
                  parseInt(meli_code.charAt(8)) * 2;
                var r = n - parseInt(n / 11) * 11;
                if (
                  (r == 0 && r == c) ||
                  (r == 1 && c == 1) ||
                  (r > 1 && c == 11 - r)
                ) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return true;
              }
            },
          },
        },
      };
    } else if (this.data.selectedNationalId === 2) {
      return {
        guestDetails: {
          adultCount: {
            $each: {
              firstName: {
                required,
                checkIsLatin: (val) => {
                  if (val === "") {
                    return false;
                  }
                  if (/^[A-Za-z\s]+$/.test(val)) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
              lastName: {
                required,
                checkIsLatin: (val) => {
                  if (val === "") {
                    return false;
                  }
                  if (/^[A-Za-z\s]+$/.test(val)) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
              nationalCode: {
                required,
                maxLength: maxLength(10),
                checKpassport: (val) => {
                  if (val === "") {
                    return false;
                  }
                  if (/^[a-zA-Z0-9]*$/.test(val)) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
            },
          },
          childCount: {
            $each: {
              firstName: {
                required,
                checkIsLatin: (val) => {
                  if (val === "") {
                    return false;
                  }
                  if (/^[A-Za-z\s]+$/.test(val)) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
              lastName: {
                required,
                checkIsLatin: (val) => {
                  if (val === "") {
                    return false;
                  }
                  if (/^[A-Za-z\s]+$/.test(val)) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
              nationalCode: {
                required,
                maxLength: maxLength(10),
                checKpassport: (val) => {
                  if (val === "") {
                    return false;
                  }
                  if (/^[a-zA-Z0-9]*$/.test(val)) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
            },
          },
          infantCount: {
            $each: {
              firstName: {
                required,
                checkIsLatin: (val) => {
                  if (val === "") {
                    return false;
                  }
                  if (/^[A-Za-z\s]+$/.test(val)) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
              lastName: {
                required,
                checkIsLatin: (val) => {
                  if (val === "") {
                    return false;
                  }
                  if (/^[A-Za-z\s]+$/.test(val)) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
              nationalCode: {
                required,
                maxLength: maxLength(10),
                checKpassport: (val) => {
                  if (val === "") {
                    return false;
                  }
                  if (/^[a-zA-Z0-9]*$/.test(val)) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
            },
          },
        },
        data: {
          firstName: {
            required,
            checkIsLatin: (val) => {
              if (val === "") {
                return false;
              }
              if (/^[A-Za-z\s]+$/.test(val)) {
                return true;
              } else {
                return false;
              }
            },
          },
          lastName: {
            required,
            checkIsLatin: (val) => {
              if (val === "") {
                return false;
              }
              if (/^[A-Za-z\s]+$/.test(val)) {
                return true;
              } else {
                return false;
              }
            },
          },
          flightNumber: {
            required: requiredIf(function (model) {
              const isValid = this.providerId == 2 ? true : false;
              return isValid;
            }),
          },
          classType: { required },
          mobileNumber: {
            required,
            maxLength: maxLength(11),
            minLength: minLength(11),
          },
          email: { email, maxLength: maxLength(100) },
          gender: { required },
          nationalCode: {
            required,
            maxLength: maxLength(10),
            checKpassport: (val) => {
              if (val === "") {
                return false;
              }
              if (/^[a-zA-Z0-9]*$/.test(val)) {
                return true;
              } else {
                return false;
              }
            },
          },
        },
      };
    }
  },
  computed: {
    mobileValidation() {
      let errors = [];
      for (let condition of this.rules) {
        if (!condition.regex.test(this.data.mobileNumber)) {
          errors.push(condition.message);
        }
      }
      if (errors.length === 0) {
        return { valid: true, errors };
      } else {
        return { valid: false, errors };
      }
    },
  },
  created() {
    this.providerName = this.$route.params.providerName;
    if (this.providerName.toLowerCase() === "fasttrack") this.providerId = 2;
    else if (this.providerName.toLowerCase() === "dolphin") this.providerId = 1;

    if (this.providerId === 1) {
      this.data.selectedNationalId = 1;
      this.title = "پارک دلفین ها";
    } else {
      this.data.selectedNationalId = 2;
      this.title = "فست ترک فرودگاه امام خمینی";
    }

    this.checkStoreData();
  },
  methods: {
    checkStoreData() {
      this.reservedData = this.$store.getters.GetSelectedReserve;
      this.customerInfo = this.$store.getters.GetCustomerInfo;

      this.guestCount = this.reservedData.guestCount;

      if (Object.keys(this.$store.getters.GetSelectedReserve).length == 0) {
        this.backToSearch();
      }

      if (Object.keys(this.$store.getters.GetCustomerInfo).length > 0) {
        this.data = this.customerInfo;
      }

      if (Object.keys(this.$store.getters.GetGuestsInfo).length > 0) {
        this.guestDetails.adultCount =
          this.$store.getters.GetGuestsInfo.adultCount;

        if (this.guestDetails.adultCount.length === 0)
          this.calcAdultGuestCount();

        this.guestDetails.childCount =
          this.$store.getters.GetGuestsInfo.childCount;

        if (this.guestDetails.childCount.length === 0)
          this.calcChildGuestCount();

        this.guestDetails.infantCount =
          this.$store.getters.GetGuestsInfo.infantCount;

        if (this.guestDetails.infantCount.length === 0)
          this.calcInfantGuestCount();
      } else {
        this.calcAdultGuestCount();
        this.calcChildGuestCount();
        this.calcInfantGuestCount();
      }
    },
    calcAdultGuestCount() {
      for (var i = 0; i < this.reservedData.adultCount - 1; i++) {
        this.guestDetails.adultCount.push({
          firstName: "",
          lastName: "",
          nationalCode: "",
          ageCategoryId: 3,
        });
      }
    },
    calcChildGuestCount() {
      const childCount =
        this.reservedData.adultCount > 0
          ? this.reservedData.childCount
          : this.reservedData.childCount - 1;

      for (var i = 0; i < childCount; i++) {
        this.guestDetails.childCount.push({
          firstName: "",
          lastName: "",
          nationalCode: "",
          ageCategoryId: 2,
        });
      }
    },

    calcInfantGuestCount() {
      //calc infant count
      for (var i = 0; i < this.reservedData.infantCount; i++) {
        this.guestDetails.infantCount.push({
          firstName: "",
          lastName: "",
          nationalCode: "",
          ageCategoryId: 1,
        });
      }
    },

    backToSearch() {
      this.$router
        .push({
          path: "/tourism/tourismSearch/" + this.providerName,
        })
        .catch(() => { });
    },
    gotoNext() { },
    onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.$store.dispatch("storeCustomerInfo", this.data);
      this.$store.dispatch("storeGuestsInfo", this.guestDetails);

      this.$router
        .push({
          path: "/tourism/confirmbook/" + this.providerName,
        })
        .catch(() => { });
    },
  },
};
</script>
<style scoped>
.content-current {
  padding: 20px !important;
  background-color: #fff;
  border: 1px solid #e2e2e2;
  border-top: none;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.rtl .form-check-label,
[dir="rtl"] .form-check-label {
  padding-right: 0.75rem;
  padding-left: 2.25rem;
}

.radio-title {
  padding-right: 0.25rem;
}

.radio-btn input {
  position: absolute;
  opacity: 1;
  cursor: pointer;
  width: 16px;
  height: 16px;
}
</style>